/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import {
  Layout,
  TopLineContainer,
  TopLine,
  PlatformInformation,
  MiddleContainer,
  MiddleCell,
  LinkContainer,
  ContactUs,
  Enamad,
  SocialMediaWrapper,
  SocialMediaTitle,
  SocialMediaContainer,
  SocialMedia,
  BottomContainer,
  RightReserve,
} from "./styles";
import Logo from "../../UIcomponent/Icon/Logo";
import PersianLogoType from "../../UIcomponent/Icon/PersianLogoType";
import Col from "../../UIcomponent/Column";
import instagram from "../../Assets/icon/instagram.svg";
import telegram from "../../Assets/icon/telegram.svg";
import twitter from "../../Assets/icon/twitter.svg";
import linkedin from "../../Assets/icon/linkedin.svg";

const Footer = () => {
  const footerBar = [
    "transparent",
    "transparent",
    "transparent",
    "transparent",
    "transparent",
  ];

  const socialMediaList = [
    {
      name: "instagram",
      icon: instagram,
      link: "https://www.instagram.com/lingotalk.io/",
    },
    {
      name: "telegram",
      icon: telegram,
      link: "https://www.t.me/lingotalk",
    },
    {
      name: "twitter",
      icon: twitter,
      link: "https://www.twitter.com/lingotalk1",
    },
    {
      name: "linkedin",
      icon: linkedin,
      link: "https://www.linkedin.com/company/lingotalk/",
    },
  ];
  const theme = useContext(ThemeContext);
  return (
    <Layout>
      <TopLineContainer>
        {footerBar.map((each, index) => {
          return (
            <TopLine
              xl={index % 2 === 0 ? 48 / 7 : 24 / 7}
              lg={index % 2 === 0 ? 48 / 7 : 24 / 7}
              md={index % 2 === 0 ? 48 / 7 : 24 / 7}
              sm={index % 2 === 0 ? 48 / 7 : 24 / 7}
              xs={index % 2 === 0 ? 48 / 7 : 24 / 7}
              color={each}
            />
          );
        })}
      </TopLineContainer>
      <PlatformInformation xl={21} lg={21} md={21} sm={22} xs={22}>
        <Logo width={35} height={35} fill={"#5340e7"} />
        <PersianLogoType
          className="footerLogoType"
          width="180"
          height="180"
          viewBox={"0 0 200 160"}
          transform={`translate(${80} ${42})`}
          fill={"#5340e7"}
        />
        <PersianLogoType
          className="footerLogoType--res"
          width="150"
          height="50"
          viewBox={"0 0 20 20"}
          transform={`translate(${8} ${9})`}
          fill={"#5340e7"}
        />
      </PlatformInformation>
      <MiddleContainer xl={21} lg={21} md={21} sm={22} xs={22}>
        <MiddleCell xl={15} lg={15} md={15} sm={24} xs={24} secondary>
          <LinkContainer xl={8} lg={8} md={8} sm={8} xs={8}>
            {/* <a href="/">درباره ما</a> */}
            <a href="/jointeacher">جذب استاد</a>
            <a href="/blog">بلاگ</a>
            {/* <a href="/">قوانین و مقررات</a> */}
          </LinkContainer>
          <LinkContainer xl={8} lg={8} md={8} sm={8} xs={8}>
            <a href="/find-teachers">لیست اساتید</a>
            <a href="/faq">پشتیبانی</a>
          </LinkContainer>
          <ContactUs xl={8} lg={8} md={8} sm={8} xs={8}>
            <Col
              style={{
                height: "30px",
                color: theme.textLight,
                fontFamily: "Fa_IRANSansMedium",
              }}
            >
              تماس با ما
            </Col>
            <Col>
              <a href="tel: 02128424770">021-28424770</a>
            </Col>
            <Col>
              <a href="mailto:hi@lingotalk.io">hi@lingotalk.io</a>
            </Col>
          </ContactUs>
        </MiddleCell>
        <MiddleCell xl={9} lg={9} md={9} sm={24} xs={24} reverse>
          <Enamad xl={12} lg={12} md={12} sm={7} xs={7}>
            <a
              target="_blank"
              href="https://trustseal.enamad.ir/?id=136309&amp;Code=e8nUVLpPL7Rnmox4xZd9"
            >
              <img
                src="https://Trustseal.eNamad.ir/logo.aspx?id=136309&amp;Code=e8nUVLpPL7Rnmox4xZd9"
                alt=""
                id="e8nUVLpPL7Rnmox4xZd9"
              />
            </a>
          </Enamad>
          <SocialMediaWrapper xl={12} lg={12} md={12} sm={17} xs={17}>
            <SocialMediaTitle>
              در شبکه‌های اجتماعی به شما نزدیک‌تریم
            </SocialMediaTitle>
            <SocialMediaContainer xl={24} lg={24} md={24} sm={24} xs={24}>
              {socialMediaList.map((each, index) => {
                return (
                  <SocialMedia>
                    <a
                      key={index}
                      target="_blank"
                      rel="noopener noreferrer"
                      href={each.link}
                      style={{
                        backgroundImage: `url(${each.icon})`,
                      }}
                    ></a>
                  </SocialMedia>
                );
              })}
            </SocialMediaContainer>
          </SocialMediaWrapper>
        </MiddleCell>
      </MiddleContainer>
      <BottomContainer xl={24} lg={24} md={24} sm={24} xs={24}>
        <RightReserve xl={21} lg={21} md={21} sm={22} xs={22}>
          {/* {String.fromCharCode(169)} */}
          ©2020 . Lingotalk . All rights reserved
        </RightReserve>
      </BottomContainer>
    </Layout>
  );
};

export default Footer;
